import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./components/home/Home";
import { Tests } from "./components/global-tests/Tests";
import { Detail } from "./components/detail-test/Detail";
import { DetailTesting } from "./components/detail-testing/DetailTesting";
import { createBrowserHistory } from "history";
import TagManager from "react-gtm-module";

//import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { GlobalTesting } from "./components/global-testing/GlobalTesting";

//import ReactGA from "react-ga";
// Google analytics and tag manager initializations.
//ReactGA.initialize("UA-2932866-3");

// TagManager.initialize({
//   gtmId: "GTM-W3XGXX2",
// });

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

TagManager.initialize({
  gtmId: "GTM-W3XGXX2",
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={`${baseUrl}/`}>
      <Routes>
        <Route path='/' element={<App />}>
          <Route index element={<Home />}></Route>
          <Route path='global-tests' element={<Tests />}></Route>
          <Route path='global-testing' element={<GlobalTesting />}></Route>
          <Route path='detail-test/:index' element={<Detail />}></Route>
          <Route path='detail-testing/:index' element={<DetailTesting />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
